import {
    createBrowserRouter,
    RouterProvider
} from 'react-router-dom';


import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@flexinet/ui-components/style.css'


import {UserAttributesContextProvider} from "./context/UserAttributesContext.tsx";
import {theme} from "./theme.ts";
import {MantineProvider} from "@mantine/core";
import {Notifications} from "@mantine/notifications";
import {ModalsProvider} from "@mantine/modals";

import {AuthProvider} from "./context/AuthContext.tsx";
import {VerifiedPermissionsProvider} from './providers/VerifiedPermissionsProvider.tsx';
import {actions} from "./config/rbac/actions.ts";
import {CognitoContextProvider} from '@flexinet/auth-components';
import {routesConfig} from "./config/routes.tsx";
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';

const router = createBrowserRouter(routesConfig)
const queryClient = new QueryClient();


export const App = () => {

    return (
        <MantineProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <VerifiedPermissionsProvider actions={actions}>
                        <UserAttributesContextProvider>
                            <CognitoContextProvider>
                                <ModalsProvider>
                                    <Notifications position={'bottom-left'}/>
                                    <RouterProvider router={router}/>
                                </ModalsProvider>
                            </CognitoContextProvider>
                        </UserAttributesContextProvider>
                    </VerifiedPermissionsProvider>
                </AuthProvider>
            </QueryClientProvider>
        </MantineProvider>
    );
}

